export default {
  introduce: {
    left: {
      costs: 'Transparent material fees',
      service: 'Service fees charged based on actual usage',
      advertisement: 'Direct advertising with rates as low as {rate}',
      limit: 'Limited',
      gift: '50 gift packages',
      contact: ',contact us now!',
      email: 'Email: creative@mindworks-creative.com',
      apply: 'Export projects and apply to campaign',
    },
    right: {
      costs: 'Production Fees',
      consume: 'Ad expenditure: $100',
      material: 'Material production fee: $3',
      low: 'As low as 3%',
    },
    banner: {
      title:
        'First 50 clients activating and completing initial deposit will get the New User Bundle!',
    },
  },
  suggest: {
    select: {
      title: 'Dual-Modes: Customize service for flexible needs',
      describe: 'Self-service and agency fee model',
    },
    lead: {
      title: 'Leading the visual revolution',
      describe: 'Rich playable library covering all industries',
    },
    data: {
      title: 'Data insights driving effectiveness',
      describe: 'Real-time optimization for improved conversions',
    },
  },
  detail: {
    title: 'Activity Details',
    main: {
      question1:
        'Is Ad Consumption-based Pricing Model suitable for all channels?',
      content1:
        'Our Ad Consumption-based Pricing Model is based on playable spend and currently supports Mintegral, Applovin and Unity.',
      question2:
        'How is the cost of playable creative calculated based on ad spend?',
      content2: {
        title:
          'For each material, the cost is calculated based on a fixed percentage of the advertising expenditure for that material. The specific value depends on the production method chosen by the advertiser',
        article1: 'Playturbo self-service platform',
        describe1:
          'When advertisers use the Playturbo self-service platform to create materials, the cost percentage is 3%. This means that you only need to pay 3% of your ad spend as the material production fee.',
        article2: 'Mindworks Creative Optimization Service',
        describe2:
          "If advertisers choose to have Playturbo's professional team create the materials (Mindworks Creative Optimization Service), the cost percentage is 6%. In this case, you would need to pay 6% of your ad spend as the material production fee.",
        tips: "By offering these different options, we aim to cater to the needs of advertisers and ensure that the cost aligns with the ad spend. Whether it's self-service production or managed production, our goal is to reduce material production costs and enable you to make the most of your advertising budget for higher returns on investment.",
      },
      question3:
        'What is the minimum deposit required? How are bills calculated?',
      content3: {
        title:
          'To use our advertising services, individual advertisers are required to make a minimum deposit of $800. This serves as a prepayment to guarantee the continuity and stability of your ad campaigns.',
        example: 'Billing Example:',
        assume:
          "Here's an example to illustrate how billing is calculated based on a monthly ad spend of 3% on Mintegral:\nSuppose you have multiple playable materials running simultaneously and start them in different months. Here's the breakdown of the monthly bills:",
        article1: 'October: Materials A, B, C, and D are created and launched:',
        october: {
          materialA: 'Material A: Ad spend of $100',
          materialB: 'Material B: Ad spend of $1000',
          materialC: 'Material C: Ad spend of $300',
          materialD: 'Material D: Ad spend of $0 (not launched)',
          cost: 'October billing:',
          costA: 'Material A cost: $100 x 3% = $3',
          costB: 'Material B cost: $1000 x 3% = $30',
          costC: 'Material C cost: $300 x 3% = $9',
          costD: 'Material D cost: $0 (not launched)',
          totalCost: 'Total for October: $3 + $30 + $9 = $42',
        },
        article2:
          'November: Materials A and B continue running, material C is stopped, and materials D and E are created and launched:',
        november: {
          materialA: 'Material A: Ad spend of $100',
          materialB: 'Material B: Ad spend of $200',
          materialC: 'Material C: Ad spend of $0 (stopped)',
          materialD: 'Material D: Ad spend of $300',
          materialE: 'Material E: Ad spend of $400',
          cost: 'November billing:',
          costA: 'Material A cost: $100 x 3% = $3',
          costB: 'Material B cost: $200 x 3% = $6',
          costC: 'Material C cost: $0 (stopped)',
          costD: 'Material D cost: $300 x 3% = $9',
          costE: 'Material E cost: $400 x 3% = $12',
          totalCost: 'Total for November: $3 + $6 + $9 + $12 = $30',
        },
        tips: '*Please note that in each monthly billing calculation, we consider the individual ad spend for each material and sum up the costs accordingly.',
      },
      interpret:
        '*Terms and conditions are subject to interpretation by Mindworks and Mintegral.',
    },
  },
  form: {
    only: 'Only',
    gif: '50 gift packages!',
    click: ', Click on the button to get now! ',
    promptly: 'Contact us promptly!',
    advertisement: 'Direct advertising',
    rate: 'Rates reduced to {rate}',
    contact: 'Contact us',
  },
}
